<script setup lang="ts">
import { type HTMLAttributes, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

import { type AObjectSelectItem, ASelectInput } from '../../../main'

defineOptions({ inheritAttrs: true })

export interface TablePaginationEmits {
  (event: 'change', size: number): void
}

export type SizeItem = AObjectSelectItem

export interface TablePageSizeSelectProperties {
  class?: HTMLAttributes['class']
  size?: number
  sizeItems?: SizeItem[]
}

const properties = withDefaults(defineProps<TablePageSizeSelectProperties>(), {
  class: undefined,
  size: 15,
  sizeItems: () => [
    { value: '5', label: '5' },
    { value: '15', label: '15' },
    { value: '25', label: '25' },
    { value: '50', label: '50' },
    { value: '100', label: '100' },
  ],
})

const emit = defineEmits<TablePaginationEmits>()
const internalSize = ref<string>(String(properties.size))

watch(
  () => internalSize.value,
  (value: string) => {
    emit('change', Number(value))
  },
)
const { t } = useI18n({
  messages: {
    en: {
      'Items per page': 'Items per page',
    },
    nl: {
      'Items per page': 'Items per pagina',
    },
    de: {
      'Items per page': 'Elemente pro Seite',
    },
  },
})
</script>

<template>
  <div class="atabix-pagination__limit">
    {{ t('Items per page') }}
    <ASelectInput
      v-model="internalSize"
      :class="['atabix-page-size-select', properties.class]"
      :items="sizeItems"
      :placeholder="t('Items per page')"
    />
  </div>
</template>

<style lang="scss">
.atabix-page-size-select {
  @apply w-[76px];
}
</style>
